export interface ILocalStorageConfig {
  secretKey: string;
  stepperList: string;
  currentStep: string;
  useSessionStorage: string;
  onboardingConfig: OnboardingConfig;
}

export interface OnboardingConfig {
  UserObject: string;
  CountriesObject: string;
  DynamicFormData: string;
  IsMalissa: string;
  userKey: string;
  departmentId: string;
  countriesOfDestination: string;
  LinkId: string;
  Counter: string;
  IsMedicalQuestionnaireCalled: string;
  AgreementType: string;
  lang: string;
}

export const LocalStorageConfig: ILocalStorageConfig = {
  secretKey: 'SDF456FGHB2FSDV',
  stepperList: 'PC_STEPPER_LIST',
  currentStep: 'PC_CURRENT_STEP',
  useSessionStorage: 'useSessionStorage',
  onboardingConfig: {
    UserObject: 'PC_ON_BOARDING_USER',
    CountriesObject: 'PC_ON_BOARDING_CountriesObject',
    DynamicFormData: 'PC_ON_BOARDING_DynamicFormData',
    IsMalissa: 'PC_ON_BOARDING_IsMalissa',
    departmentId: 'PC_ON_BOARDING_DEPARTMENT_ID',
    userKey: 'PC_ON_BOARDING_USER_KEY',
    IsMedicalQuestionnaireCalled: 'PC_ON_BOARDING_IS_MEDICAL_QUESTIONNAIRE_CALLED',
    countriesOfDestination: 'PC_ON_BOARDING_COUNTRIES_OF_DESTINATION',
    LinkId: 'PC_ON_BOARDING_LinkId',
    Counter: 'PC_ON_BOARDING_Counter',
    AgreementType: 'PC_ON_BOARDING_AgreementType',
    lang: 'PC_ON_BOARDING_lang'
  }
};

export const Boolean = {
  true: 'true',
  false: 'false'
};
